export default __webpack_public_path__ + "static/media/values_image.0faf4262.svg";